//@flow
import React from "react";
import fluxfix from "../../services/fluxfix";

//  $FlowFixMe
import css from "./ui-panel.module.scss";
import { Container } from "flux/utils";
import {  Actions } from "../../services/actions";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle, faPauseCircle, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import CircleSlider from "../../lib/circle-controller";
// import { SourceType } from "./source";
import Store from "../../services/store";

type Props = {
  station:Object
  // livemetadata: Object
};
type State = {
  store: Object,
  // appStore: Object,
};

class Panel extends React.Component<Props, State> {
  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return { store: Store.getState()};
  }

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }
  ref: Object;

  componentDidMount() {
    this.ref.current &&
      this.ref.current.addEventListener(
        "touchmove",
        function (e) {
          e.preventDefault();
        },
        false
      );
  }
  handleTogglePlay(e: SyntheticMouseEvent<*>) {
    Actions.togglePlay();
  }

  handleSeek(s: number) {
    Actions.setCurrentTime(s);
    // window.controls.seek(s);
    window.audioRef.current.currentTime=s;
  }

  handleToggleShowPanel() {
    Actions.setHidePanel(!this.state.store.get("hidePanel"));
  }

  secsToTime(secs: number): string {
    const c = moment.duration(secs, "seconds");

    const h = String(c.hours()).padStart(2, "0");
    const m = String(c.minutes()).padStart(2, "0");
    const s = String(c.seconds()).padStart(2, "0");
    return `${h}:${m}:${s}`;
  }

  render() {
    const hide = this.state.store.get("hidePanel");
    const audioSource = this.state.store.get("currentSrc");

    if (!audioSource) return null;
    const playState = this.state.store.get("playState");
    // const isBuffering = this.state.store.get("isBuffering");
    // const meta = this.state.appStore.get("nowOn");
    // const stations = this.state.appStore.get("stations");
    const isLiveStream = audioSource?.isLiveStream;
    const station = this.props.station;

    let nowShowName = isLiveStream ? station?.nowFeature?.name || station?.name : station?.feature.name;
    let nowShowDescription = isLiveStream ? station?.nowFeature?.description || station?.shortDescription  : station?.description;

    if(nowShowName ==="In Demand Radio"){
      nowShowName = station?.name;
      nowShowDescription = station?.shortDescription;
    }


    // const nowShowName = isLiveStream ? (meta && meta["NowShowName"]) || "none" : audioSource?.title;
    // const nowShowDescription = isLiveStream ? (meta &&meta["NowShowDescription"] )|| "nonedesec" : audioSource?.description;
    const img = isLiveStream ? station?.nowFeature?.image || station?.logoSq : station?.feature?.image;
    const nowSong = isLiveStream && station?.nowFeature?.displayNowPlaying !== false ? station?.nowSong?.title : null;
    const nowArtist = isLiveStream && station?.nowFeature?.displayNowPlaying !== false ? station?.nowSong?.artistDisplay : null;

    const timing = !isLiveStream && this.secsToTime(this.state.store.get("currentTime")) + " / " + this.secsToTime(this.state.store.get("duration"));

    const height = hide ? "-1000px" : "0px";

    const backgroundStyle = {
      height: hide ? "0" : "100vh",
      opacity: hide ? 0 : 1,
    };

    const icon = playState==="BUFFERING" ? faSyncAlt : playState==="PLAYING" ? faPauseCircle : faPlayCircle;

    return (
      <div
        className={css.panelWrapper}
        style={{
          bottom: height,
        }}
        ref={this.ref}
      >
        <div className={css.panel}>
          <div className={css.panelText}>
            <div className={css.nowPlaying}>Playing</div>
            <div className={css.featureName}>{nowShowName}</div>
            <div className={css.episodeName}>{nowShowDescription}</div>
            <div className={css.timing}>{timing}</div>
            {nowSong ? (
              <div className={css.nowSong}>
                NOW: {nowSong} by {nowArtist}
              </div>
            ) : null}
          </div>
          <div className={css.circleControlWrapper}>
            <div className={css.blurImage} style={{ backgroundImage: `url(${img})` }} />

            <div className={css.circleControl}>
              <CircleSlider
                onSeek={isLiveStream ? () => {} : (e) => this.handleSeek(e)}
                onClick={isLiveStream ? () => {} : (e) => this.handleTogglePlay(e)}
                value={isLiveStream ? 0 : this.state.store.get("currentTime")}
                rangeMax={isLiveStream ? 1 : this.state.store.get("duration")}
              />

              <div className={css.circleControlIcon} onClick={(e) => this.handleTogglePlay(e)}>
                <FontAwesomeIcon icon={icon} spin={playState === "BUFFERING"} />
              </div>
            </div>
          </div>
        </div>
        <div className={css.panelFade} style={backgroundStyle} onClick={() => this.handleToggleShowPanel()} />
      </div>
    );
  }
}

export default (Container.create(fluxfix.convert(Panel)): Object);
